
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Order } from "@/types/order";
import { Separator } from "../ui/separator";

interface OrderSummaryProps {
  order: Order;
}

export function OrderSummary({ order }: OrderSummaryProps) {
  return (
    <Card className="rounded-2xl">
      <CardHeader>
        <CardTitle>Order Summary</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {order.items.map((item) => (
            <div key={item.id} className="flex justify-between items-center">
              <div className="flex items-center gap-4">
                <img src={item.image} alt={item.title} className="w-12 h-12 object-cover rounded-lg" />
                <div>
                  <p className="font-medium">{item.title}</p>
                  <p className="bodysmall text-muted-foreground">Quantity: {item.quantity}</p>
                </div>
              </div>
              <p className="font-medium">₦{(item.price * item.quantity).toLocaleString()}</p>
            </div>
          ))}
          <Separator />
          <div className="space-y-2">
            <div className="flex justify-between">
              <p>Subtotal</p>
              <p>₦{order.items.reduce((acc, item) => acc + item.price * item.quantity, 0).toLocaleString()}</p>
            </div>
            <div className="flex justify-between">
              <p>Delivery Fee</p>
              <p className="text-sm">Not set</p>
            </div>
            <Separator />
            <div className="flex justify-between font-bold text-lg">
              <p>Total</p>
              <p>₦{order.total.toLocaleString()}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
